export default {
  'error.auth.login': 'Neplatné prihlasovacie údaje.',
  'error.pass.download.failed': 'Sitahnutie karty se nepodarilo.',

  'confirmation.title': 'Upozornenie',
  'confirmation.button.yes': 'Potvrdiť',
  'confirmation.button.no': 'Zrušiť',

  'link.copy.success': 'Odkaz bol skopírovaný do schránky.',

  'pass.publish.confirmation': 'Zmeny budú publikované a všetkým uživatelom bude poslaná notifikácia.',
  'pass.edit.success': 'Zmeny boli uložené',
  'pass.publish.success': 'Zmeny boli publikované',
  'pass.download.invalid': 'Neznáma karta.',

  'value.contact-type.label.PHONE': 'Telefón',
  'value.contact-type.label.EMAIL': 'E-mail',
  'value.contact-type.label.WEB': 'Web'
}

export const datePickerMessages = {
  search: 'Hľadať',
  notfound: 'Nič sa nenašlo',
  categories: {
    search: 'Výsledok hľadania',
    recent: 'Nejčastejšie používané',
    people: 'Smileys & ľudia',
    nature: 'Zvieratá & príroda',
    foods: 'Jedlo & pitie',
    activity: 'Aktivity',
    places: 'Cestovanie & miesta',
    objects: 'Objekty',
    symbols: 'Symboly',
    flags: 'Vlajky',
    custom: 'Vlastné'
  }
}
